/*eslint-disable */

import { bus } from '@/main';

export default {
  name: 'payment-failed',
  components: {},
  props: [],
  data () {
    return {
      supportChatActv:true
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('chatSupportViewCloseOuterStateBus', (data) => {
      if(data){
        this.supportChatActv = true
      }
    })
    bus.$on('chatSupportViewOpenOuterStateBus', (data) => {
      if(data){
        this.supportChatActv = false
      }
    })
  },
  methods: {
    needHelpMethod(){
      if(!this.supportChatActv) return;
      const supportChatIconBtn = document.getElementById("helpChatRoomId");
      supportChatIconBtn.click();
      this.supportChatActv = false
    }
  }
}